module.exports = __webpack_public_path__ + "img/IMG_8473_P_L_Wood.4a8e9461.jpg";